<template>
    <div>
        <!-- <el-form :inline="true" class="user-search">
            <el-form-item label="分组">
                <el-select v-model="pageparm.type" placeholder="请选择">
                    <el-option v-for="item in typeArr" :key="item.value" :label="item.key" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="selectSlideshow()">查询</el-button>
            </el-form-item>

            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
            </el-form-item>
        </el-form> -->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column prop="id" :align="'center'" label="ID"> </el-table-column>
            <el-table-column prop="gameName" :align="'center'" sortable label="游戏名"> </el-table-column>
            <el-table-column prop="gameTypeName" :align="'center'" sortable label="游戏类型名"> </el-table-column>
            <el-table-column prop="nickName" :align="'center'" sortable label="用户昵称"> </el-table-column>
            <el-table-column prop="swmopsis" :align="'center'" sortable label="商品名称"> </el-table-column>
            <el-table-column prop="gameImg" :align="'center'" sortable label="商品图片">
                <template slot-scope="scope">
                    <img v-if="scope.row.gameImg" style="width: 90px;height: 90px;" :src="scope.row.imageUrl" />
                    <div v-if="scope.row.gameImg == null">暂无用户头像</div>
                </template>
            </el-table-column>

            <!-- <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteSlideshow(scope.row)">删除</el-button>
                </template>
            </el-table-column> -->
        </el-table>
    </div>
</template>

<script>
import { UserGoodsList } from "../../../api/userMG";
import Pagination from "../../../components/Pagination.vue";
export default {
    // 注册组件
    components: {
        Pagination
    },
    props: {
        id: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 20,
                total: 10,
                type: ""
            },
            listData: [], //
            userId:'',
            loading:false,

        }
    },
    watch: {
        // 观察 id prop 的变化
        id(newVal, oldVal) {
            console.log('newVal-----',newVal)
            console.log('oldVal-----',oldVal)
            this.userId=newVal
            this.getUserGoodsList();
        }
    },
    // created() {
    //     this.getUserGoodsList();
    //     console.log(this.id.id, '-------id')
    // },
    methods: {
        getUserGoodsList() {
            this.loading = true;
            let obj = {
                page: (this.pageparm.currentPage - 1) * 20,
                userId: this.userId,
                // userId: 148,
                state: -1,
            }
            UserGoodsList(obj).then(res => {
                this.loading = false;
                if (res.code == 200) {
                    this.listData = res.data.data;
                    // return;
                }
            })

        }
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/user/components/userGoods.vue